export const AGE_BANDS = ['3-5', '6-8', '9-12'] as const
export const MAX_CHILDREN = 10

export const REGISTRATION = {
  label: 'Registration',
  amount: '$65',
  unit: 'per child, per year',
  note: 'Covers both seasons and includes a Volley Quest T-shirt in your child’s size. Waived for families coming back for another year.',
}

// $25 x 10 is $250, so paying up front is a week free. Both numbers are
// stated on the card rather than just the discount, because a parent
// comparing them should not have to do the multiplication.
export const SEASON_PRICING = [
  {
    label: 'Week by week',
    amount: '$25',
    unit: 'per week',
    note: 'Pay as the season goes — $250 across a full ten weeks.',
    best: false,
  },
  {
    label: 'Whole season, up front',
    amount: '$225',
    unit: 'for all ten weeks',
    note: 'Paid before the season starts. That is a week free.',
    best: true,
  },
]

export const COACH_POINTS = [
  {
    label: 'Experienced',
    text: 'Coaches who have played and coached the sport, and who know the difference between coaching a five-year-old and coaching a twelve-year-old.',
  },
  {
    label: 'Background checked',
    text: 'Every coach clears a background check before they run a single session, and again every year.',
  },
  {
    label: 'CPR certified',
    text: 'Current CPR and first-aid certification is required of every coach on the court.',
  },
]

export const STAGES = [
  {
    ages: 'Ages 3-5 - Balloon',
    title: 'Keep it up',
    blurb: 'Almost none of this looks like volleyball to a parent watching. All of it is volleyball.',
    skills: [
      'Tracking a moving object with the eyes',
      'Getting under the ball before it arrives',
      'Two hands, above the forehead, every time',
      'Waiting for a turn without losing interest',
    ],
  },
  {
    ages: 'Ages 6-8 - Beach ball',
    title: 'Make it go where you want',
    blurb: 'The ball gets faster and heavier. Aim starts to matter, and so does the person next to you.',
    skills: [
      'Forearm passing platform - flat, no swing',
      'Underhand serve over a lowered net',
      'Calling the ball out loud before you play it',
      'Moving to a spot instead of reaching for it',
    ],
  },
  {
    ages: 'Ages 9-12 - Volleyball',
    title: 'Play the actual game',
    blurb: 'A lighter ball and a lower net, but a real rally: three contacts, a real serve, a real score.',
    skills: [
      'Bump, set, hit as a connected sequence',
      'Overhand serve with a consistent toss',
      'Rotation, court coverage, reading the other side',
      'Losing a point and playing the next one anyway',
    ],
  },
]
